import { Card } from '@shared/components';
import type { SummaryTile } from '../utils/invoicingSummary';

interface Props {
    tiles: SummaryTile[];
}

export function InvoicingSummaryTiles({ tiles }: Props) {
    return (
        <dl className="grid grid-cols-1 gap-3 @min-[30rem]:grid-cols-2">
            {tiles.map((tile) => (
                <Card key={tile.id} className="px-4 py-3">
                    <dt className="text-sm text-mp-muted">{tile.label}</dt>
                    <dd className="mt-1 text-xl font-semibold text-mp-foreground tabular-nums">
                        {tile.value}
                        {tile.detail !== null && (
                            <span className="block text-xs font-normal text-mp-muted">{tile.detail}</span>
                        )}
                    </dd>
                </Card>
            ))}
        </dl>
    );
}
